/**
 * View toc block.
 * @module components/manage/Blocks/ToC/View
 */

import React from 'react';
import PropTypes from 'prop-types';
import { map, filter } from 'lodash';
import { List } from 'semantic-ui-react';
import { defineMessages, injectIntl } from 'react-intl';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { normalizeString } from 'volto-fzj-internet/helpers';
import Slugger from 'github-slugger';
import { serializeNodesToText } from '@plone/volto-slate/editor/render';

import {
  getBlocksFieldname,
  getBlocksLayoutFieldname,
} from '@plone/volto/helpers';

const messages = defineMessages({
  text: {
    id: 'Table of Contents',
    defaultMessage: 'Table of Contents',
  },
});

/**
 * View toc block class.
 * @class View
 * @extends Component
 */
const View = ({ properties, data, intl }) => {
  const blocksFieldname = getBlocksFieldname(properties);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(properties);
  const placeholder = data?.placeholder || intl.formatMessage(messages.text);

  return (
    <div className="block table-of-contents">
      <h2>{placeholder}</h2>
      <List bulleted>
        {map(
          filter(
            map(properties[blocksLayoutFieldname].items, (id) => {
              const blockProperties = properties[blocksFieldname][id];
              return { id: id, ...blockProperties };
            }),
            (block) =>
              block['@type'] === 'slate' &&
              block.value &&
              block.value[0] &&
              block?.value[0]?.type.indexOf('h') === 0,
          ),
          (block) => (
            <List.Item
              key={block.id}
              className={
                block?.value[0]?.type === 'h2' ? 'header-two' : 'header-three'
              }
            >
              <AnchorLink
                href={`#${Slugger.slug(
                  normalizeString(
                    serializeNodesToText(block.value[0].children),
                  ),
                )}`}
              >
                {block.plaintext}
              </AnchorLink>
            </List.Item>
          ),
        )}
      </List>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
View.propTypes = {
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default React.memo(injectIntl(View));
